import { TranslateService } from '@ngx-translate/core';

export type CoverageState = 'not-planned' | 'under' | 'on-track' | 'annual-qualified';

export interface CoverageBadge {
    state: CoverageState;
    label: string;
}

export function coverageRatio(
    planned: number | null | undefined,
    actual: number,
): number | null {
    if (planned == null || planned <= 0) return null;
    return actual / planned;
}

export function resolveCoverage(
    planned: number | null | undefined,
    actual: number,
    translate: TranslateService,
    isFullYearWindow: boolean,
): CoverageBadge {
    if (planned == null) {
        return { state: 'not-planned', label: translate.instant('Not planned') };
    }
    if (!isFullYearWindow) {
        return {
            state: 'annual-qualified',
            label: `${actual} vs ${planned} (${translate.instant('annual')})`,
        };
    }
    const state: CoverageState = actual >= planned ? 'on-track' : 'under';
    return { state, label: `${actual} / ${planned}` };
}
